import { useEffect, useState } from "react";
import { OrgPaymentSetting } from "@graffer-inc/cloud-gov-core";
import tenantManagementApiClient from "../../../../application/apis/tenant-management/tenant-management-client";
import { reportUnexpectedError } from "@graffer-inc/smart-apply";

type Props = {
  orgId: string;
};

export const usePaymentsRawdataPageHooks = ({ orgId }: Props) => {
  const [orgPaymentSetting, setOrgPaymentSetting] = useState<
    OrgPaymentSetting | undefined
  >(undefined);

  const fetchOrgPaymentSetting = async (orgId: string) => {
    try {
      const { data } =
        await tenantManagementApiClient.fetchOrgPaymentSetting(orgId);
      setOrgPaymentSetting(data);
    } catch (e) {
      reportUnexpectedError(e);
    }
  };

  useEffect(() => {
    fetchOrgPaymentSetting(orgId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    orgPaymentSetting,
  };
};
